import { RestaurantTableStatus } from '../../../../types/restaurant/RestaurantTableTypes';

interface TableStatusBadgeProps {
  status: RestaurantTableStatus;
}

const statusConfig: Record<
  RestaurantTableStatus,
  {
    label: string;
    className: string;
  }
> = {
  FREE: {
    label: 'Libre',
    className: 'bg-success/10 text-success border-success/20',
  },
  OCCUPIED: {
    label: 'Ocupada',
    className: 'bg-danger/10 text-danger border-danger/20',
  },
  RESERVED: {
    label: 'Reservada',
    className: 'bg-primary/10 text-primary border-primary/20',
  },
  CLEANING: {
    label: 'En limpieza',
    className: 'bg-warning/15 text-warning border-warning/20',
  },
  OUT_OF_SERVICE: {
    label: 'Fuera de servicio',
    className: 'bg-bodydark2/10 text-bodydark2 border-bodydark2/20',
  },
};

const TableStatusBadge = ({
  status,
}: TableStatusBadgeProps) => {
  const config = statusConfig[status];

  return (
    <span
      className={`rounded-full border px-2.5 py-1 text-xs font-medium ${config.className}`}
    >
      {config.label}
    </span>
  );
};

export default TableStatusBadge;